// extracted by mini-css-extract-plugin
export default {"lazyImage":"nU2sw3N","silver":"hTHiegI","darkGrey":"QT1UY6k"};